import { pdf } from '@react-pdf/renderer';
import React, { useEffect, useState } from 'react';
import { Modal, Button, Form, Dropdown } from 'semantic-ui-react';
import LtoPdfDocument from './LtoBatchLabelGeneration';
import agent from '../../app/api/agent';

interface LtoLabelModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  selectedItems: Map<number, string>;
  setSelectedItems:(items: Map<number, string>) => void; // ✅ added
}

const LtoLabelModal: React.FC<LtoLabelModalProps> = ({ open, setOpen, selectedItems,setSelectedItems }) => {
  const [formData, setFormData] = useState({
    originalLto: '',
    clonedLto: '',
    ltoType: [] as string[],
  });

  const [selectedTitles, setSelectedTitles] = useState<any[]>([]);

  useEffect(() => {
    const selectedIds = Array.from(selectedItems.keys());
    (async () => {
      const payload = {
        itemGrp: selectedIds,
      };
      const res: any = await agent.NFAI.LTOBatchLabel(payload);
      setSelectedTitles(res.data);
    })();
  }, [selectedItems]);

  const ltoTypeOptions = [
    { key: 'DPX(RAWcooked)', text: 'DPX(RAWcooked)', value: 'DPX(RAWcooked)' },
    { key: 'DSM(RAWcooked)', text: 'DSM(RAWcooked)', value: 'DSM(RAWcooked)' },
    { key: 'DPX(FFV1-RAWcooked)', text: 'DPX(FFV1-RAWcooked)', value: 'DPX(FFV1-RAWcooked)' },
    { key: 'DSM(FFV1-RAWcooked)', text: 'DSM(FFV1-RAWcooked)', value: 'DSM(FFV1-RAWcooked)' },
  ];

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleDropdownChange = (_e: any, data: any) => {
    setFormData(prev => ({ ...prev, ltoType: data.value }));
  };

  const handleDownload = async () => {
    const blob = await pdf(
      <LtoPdfDocument
        originalLto={formData.originalLto}
        clonedLto={formData.clonedLto}
        ltoType={formData.ltoType}
        selectedTitles={selectedTitles}
      />
    ).toBlob();

    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${formData.originalLto}_LTO_labels.pdf`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);

    // ✅ Close the modal after download is triggered
    setOpen(false);
    setSelectedItems(new Map());
  };

  return (
    <Modal open={open} onClose={() => setOpen(false)} size="large">
      <Modal.Header>Generate LTO Label</Modal.Header>
      <Modal.Content>
        <Form>
          <Form.Group widths="equal">
            <Form.Field>
              <label>ORIGINAL LTO</label>
              <input
                name="originalLto"
                placeholder="Enter original LTO"
                value={formData.originalLto}
                onChange={handleInputChange}
              />
            </Form.Field>

            <Form.Field>
              <label>CLONED LTO</label>
              <input
                name="clonedLto"
                placeholder="Enter cloned LTO"
                value={formData.clonedLto}
                onChange={handleInputChange}
              />
            </Form.Field>

            <Form.Field>
              <label>RAWCOOKED Type</label>
              <Dropdown
                placeholder="Select LTO Type"
                fluid
                selection
                multiple
                options={ltoTypeOptions}
                value={formData.ltoType}
                onChange={handleDropdownChange}
              />
            </Form.Field>
          </Form.Group>

          <p style={{ marginTop: '1em' }}>
            <strong>Selected Titles:</strong>
            <ul>
              {selectedTitles.map((title, index) => (
                <li key={index}>{title}</li>
              ))}
            </ul>
          </p>
        </Form>
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={() => setOpen(false)}>Cancel</Button>

        <Button
          color="teal"
          onClick={handleDownload}
          disabled={
            !formData.originalLto ||
            !formData.clonedLto ||
            formData.ltoType.length === 0 ||
            selectedTitles.length === 0
          }
        >
          Download PDF
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

export default LtoLabelModal;
